<template>
	<div class="artist-detail-meta">
		<template v-for="item in metadata" :key="item.label">
			<div v-if="item.value" class="artist-meta-item">
				<label class="artist-meta-item-label">{{ item.label }}:</label>

				<!-- link -->
				<a v-if="item.type == 'link'" class="artist-meta-item-value" :href="item.value" target="_blank">
					{{item.link_text }}
				</a>

				<!-- badge -->
				<span v-else-if="item.type == 'badge'" class="badge bg-primary">{{ item.value }}</span>

				<!-- weight -->
				<span v-else-if="item.type == 'weight'" class="artist-meta-item-value">{{ weight(item.value) }}</span>

				<!-- dimension-->
				<span v-else-if="item.type == 'dimension'" class="artist-meta-item-value">{{ dimension(item.value) }}</span>
				<span v-else-if="item.type == 'dimension'" class="artist-meta-item-value">{{ dimension(item.value) }}</span>
				<span v-else-if="item.type == 'dimension'" class="artist-meta-item-value">{{ dimension(item.value) }}</span>

				<!-- money -->
				<span v-else-if="item.type == 'money'" class="artist-meta-item-value">{{ money(item.value) }}</span>



				<!-- text -->
				<span v-else class="artist-meta-item-value">{{ item.value }}</span>
			</div>
		</template>
	</div>
</template>

<script>
 export default {
	props: {
		metadata: {
			type: Object,
			required: true
		}
	},

	methods: {
		weight: function (value) {
			// console.log('weight', value);
			return value.replace(/[^0-9\.]*/g, '') + ' kg';
		},

		dimension: function (value) {
			// console.log('weight', value);
			return value.replace(/[^0-9\.]*/g, '') + ' cm';
		},

		money: function (value) {
			return '$' + value.replace(/[^0-9\.]*/g, '');
		}
	}
 }

/*
[
	{
		label: 'Title',
		value: this.artwork.title,
		type: 'text'
	}
]
*/
</script>